import React, { ReactNode } from 'react';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { JETScooberTheme } from '@src/themes/JETTheme';
interface componentProps {
  children: ReactNode;
}

export const ScooberTheme = ({ children }: componentProps) => {
  
  return (
    <MuiThemeProvider theme={JETScooberTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
